import Header from '../components/Header.jsx';
import Footer from '../components/Footer.jsx';
import Section from '../components/Section.jsx';
import Gallery from '../components/Gallery.jsx';

// The article text is the original Hinglish copy, kept verbatim.
const PARAGRAPHS = [
  'Bijaipur rehasat ka antim gaav, jo Amarpura se 12km duri par uttar disha mai sthit hai.Jile ka sabse bada prakratic jalashay hai, jo satat 300 barso se bhara hua hai. Esa mana jata hai ki takriban 300 salo purve paangarh mai ek raja ka rajye tha .Uske rajye mai bhisan akal pada tha, tab ek rishi mahatama ne kaha ki agar apka rajkumar and uski patni agar dono kile ke neeche bane hue madan mai alag rahe tatha kisi se na mile to aapke rajye mai barish ho sakti hai.Eske ek saal baad hi barsaat hue aur itni jor se hue ki samast madan jaha rajkumar tatha uski patni rahate the pani se bhar gaya.Kai varso tak unka ghar pani mai hi duba raha. log kahate he ki lagbhag 50 varso tak pani mai dube hue ghar se dhuaa nikalta tha iska matlab rajkumar and uski patni dono pani ke under bhi 50 varso tak jivit rahe.',
  'Is kahani se prabhavit hokar 100 vars purve gangrar ka ek kinner(hijda,having no child) jab paangarh pahucha to usne talab ke paas jakar kaha ki, agar is jalashay mai rajkumar tatha uski patni ne sachmuch mai jal samadhi li ho to mai ek kinner hote hue bhi kisi bache ki maa ban jaauga .kuch hi deno baad uske ek bacha pada hua jiska naam usne "Jhunkavar" rakha. Tabhi se us sthan ka naam jhunkavar ho gaya aur yahe ek pavan sthan ban gaya. uski tarah kai santaanhin dampati yaha aate hai tatha palna bandhate hai aur unko santaan ki prapti hoti hai. paangrh videshi prayatak ka mukhay aakrashan kendra hai.',
  "Boating resort ,hotel's,camp fire aadi bhi uplabdha(available) hai",
];

const Paangarh = () => (
  <div id="page">
    <Header
      plain
      title="Paangarh"
      kicker="Near by · 12 km north"
      tagline="The district's largest natural lake, held full for three hundred years."
    />

    <Section eyebrow="Brief" title="Paangarh">
      <div className="intro intro--with-figure">
        <div className="prose prose--lead stack">
          {PARAGRAPHS.map((text, i) => (
            <p key={i} className="reveal">
              {text}
            </p>
          ))}
        </div>
        <figure className="figure reveal">
          <img
            src="/images/paangarh/paangarh1.jpg"
            alt="The hill above Paangarh lake"
            width="448"
            height="336"
          />
          <figcaption>The fort hill above the lake.</figcaption>
        </figure>
      </div>
    </Section>

    <Gallery
      type="paangarh"
      title="Photographs"
      lead="The lake, the fort wall and Jhunkavar."
    />
    <Footer />
  </div>
);

export default Paangarh;
